let __index = 0;
export const getKey = (prefix) => prefix+ "__" + (__index++)
